import { render } from "./DocumentViewSwitcher.vue?vue&type=template&id=2570a390&scoped=true"
import script from "./DocumentViewSwitcher.vue?vue&type=script&lang=js"
export * from "./DocumentViewSwitcher.vue?vue&type=script&lang=js"

import "./DocumentViewSwitcher.vue?vue&type=style&index=0&id=2570a390&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2570a390"]])

export default __exports__